import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { createDropdown } from 'ckeditor5/src/ui';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import InputTextView from '@ckeditor/ckeditor5-ui/src/inputtext/inputtextview';
import View from '@ckeditor/ckeditor5-ui/src/view';
import FAIconView from "./fa-icon-view";
import IconStrokeRounded from './ico-stroke-rounded.svg';

function getSelectedFaIconClass(editor) {
    const selection = editor.model.document.selection;
    const selectedElement = selection.getSelectedElement();

    if (selectedElement && selectedElement.name === 'faIcon') {
        return selectedElement.getAttribute('faIconClass') || '';
    }

    return '';
}

function handleIconSelection(editor, iconClass) {
    const selected = editor.model.document.selection.getSelectedElement();
    editor.model.change(writer => {
        if ( selected && selected.name === 'faIcon' ) {
            writer.setAttribute( 'faIconClass', iconClass, selected );
            const viewElement = editor.editing.mapper.toViewElement(selected);
            const iViewEl = viewElement.getChild(0);
            const iEl = editor.editing.view.domConverter.mapViewToDom(iViewEl);
            iEl.className = iconClass;
        }
        else {
            const e = writer.createElement('faIcon', {
                faIconClass: iconClass
            });
            editor.model.insertContent(e, editor.model.document.selection);
        }
    });
}

export default class FontAwesomeUI extends Plugin {

    static get pluginName() {
        return 'FontAwesomeUI';
    }

    constructor( editor ) {
        super( editor );
        this.icons = editor.config.get('fontAwesome.icons') || [
            { label: 'home', value: 'fas fa-home' },
            { label: 'user', value: 'fas fa-user' },
            { label: 'star', value: 'fas fa-star' },
            { label: 'cog', value: 'fas fa-cog' }
        ];
    }

    init() {
        const editor = this.editor;
        const locale = editor.locale;
        const t = locale.t;
        const command = editor.commands.get( 'fontColor' );
        // Register the UI component.
        editor.ui.componentFactory.add( 'fontAwesome', locale => {
            const dropdownView = createDropdown( locale );

            dropdownView.buttonView.set( {
                label: t('Icon'),
                icon: IconStrokeRounded,
                tooltip: true
            } );

            dropdownView.extendTemplate( {
                attributes: {
                    class: 'ck-fa-ui-dropdown'
                }
            } );

            dropdownView.bind( 'isEnabled' ).to( command );

            dropdownView.on( 'execute', ( evt, data ) => {
                editor.execute( this.commandName, data );
                editor.editing.view.focus();
            } );

            const items = new Collection();
            const useCustomBtn = new ButtonView(locale);
            useCustomBtn.iconView = new FAIconView(locale);
            useCustomBtn.set({
                label: t('Use custom'),
                withText: true,
                icon: 'fas'
            });
            useCustomBtn.isVisible = false;
            // --- 1️⃣ Create search input ---
            const searchInput = new InputTextView(locale);
            searchInput.on('change:value', () => {
                const query = searchInput.value.toLowerCase();
                let exists = false;
                for (const btn of items) {
                    const label = btn.tooltip.toLowerCase();
                    btn.isVisible = label.includes(query);
                    exists = exists || btn.isVisible;
                }
                useCustomBtn.isVisible = !exists && searchInput.value.trim().startsWith('fa') && searchInput.value.includes('-');
                if (useCustomBtn.isVisible) {
                    useCustomBtn.set({
                        icon: searchInput.value.trim()
                    });
                }
            });
            searchInput.on('input', () => {
                let value = searchInput.element.value.trim();
                let v = value.trim();
                if (v.startsWith('<i ') && v.endsWith('</i>')) {
                    const temp = document.createElement('div');
                    temp.innerHTML = value;
                    const iEl = temp.querySelector('i');
                    if (iEl.className) {
                        value = iEl.className;
                    }
                }
                searchInput.element.value = value;
                searchInput.value = value;
            });
            useCustomBtn.on('execute', () => {
                handleIconSelection(editor, searchInput.element.value);
                searchInput.value = '';
                searchInput.element.value = '';
                dropdownView.isOpen = false;
            });

            const searchContainer = new View(locale);
            searchContainer.setTemplate({
                tag: 'div',
                attributes: {
                    class: [ 'row' ]
                },
                children: [searchInput]
            });

            dropdownView.panelView.children.add(searchContainer);

            dropdownView.on( 'change:isOpen', ( evt, name, isVisible ) => {
                if (isVisible) {
                    const selectedClass = getSelectedFaIconClass(editor);
                    let exists = false;
                    for (const btn of items) {
                        const r = btn.children.first.content === selectedClass;
                        exists = exists || r;
                        btn.isEnabled = !r;
                    }
                    if (!exists) {
                        searchInput.value = selectedClass;
                        searchInput.element.value = selectedClass;
                    }
                }
            } );




            this.icons.forEach((icon, index) => {
                const button = new ButtonView(locale);
                button.iconView = new FAIconView(locale);
                button.set({
                    withText: false,
                    icon: icon.value,
                    id: 'fa-icon-' + index,
                    tooltip: icon.label
                });

                button.on('execute', () => {
                    handleIconSelection(editor, icon.value);
                    dropdownView.isOpen = false;
                });
                items.add(button);
            });

            // Attach items to the dropdown panel
            const iconListContainer = new View(locale);
            iconListContainer.setTemplate({
                tag: 'div',
                attributes: {
                    class: [ 'row', 'icon-list-container' ]
                },
                children: items
            });
            dropdownView.panelView.children.add(iconListContainer);
            dropdownView.panelView.children.add(useCustomBtn);
            return dropdownView;
        } );
    }
}